import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { NotificationService } from '@components/notification/notification.service';
import { DomainErrorService } from '@services/domain-error.service';
import { catchError, Observable, throwError } from 'rxjs';

/**
 * Interceptor for handling errors showing in modal or snackbar.
 */
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly domainErrorService: DomainErrorService,
    private readonly notification: NotificationService,
  ) {}

  intercept(
    request: HttpRequest<Record<string, unknown>>,
    next: HttpHandler,
  ): Observable<HttpEvent<Record<string, unknown>>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const message = this.getNotificationMessage(error);
        if (error.status === 409 && this.domainErrorService.error.observed) {
          this.domainErrorService.setError(message);
        } else if (error.status !== 400) {
          this.notification.showError({ message });
        }
        return throwError(() => error);
      }),
    );
  }

  private getNotificationMessage(error: HttpErrorResponse): string {
    const isConflictStatusError = error.status === 409;
    const noPermissionStatusError = error.status === 403;
    if (isConflictStatusError) {
      return (error.error as { title: string; status: number; detail: string }).detail;
    } else if (noPermissionStatusError) {
      return $localize`Przepraszamy, nie posiadasz wymaganych uprawnień do wykonania akcji.`;
    }
    const isClientSideError = error.status / 100 === 4;
    return isClientSideError
      ? $localize`Przepraszamy, nastąpił nieoczekiwany błąd po stronie klienta.`
      : $localize`Przepraszamy, nastąpił nieoczekiwany błąd po stronie serwera.`;
  }
}
